import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, DAYS_QTR, PAGE_SIZE } from '../../common/constants';
import { formatTo0Decimal, formatTo1Decimal, isEmpty, isEmptyArray, isZero } from '../../common/util.services';
import { getProductMargin, getInvAttribute, getAllProducts } from '../amazon.services';
import { Grid } from '@mui/material';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';
import ICheckbox from '../../../components/checkbox/i-checkbox.component';

const AmazonProductMargin = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [marginData, setMarginData] = useState(rows);
  const [searchData, setSearchData] = useState<any>({product: ALL, color: 'Total', size: 'Total', pack: 'Total', inactive: false,
                                                     startDate: dayjs().subtract(DAYS_QTR, 'day'), endDate: dayjs()});
  const [colorList, setColorList] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [packList, setPackList] = useState([]);
  const [prdList, setPrdList] = useState([]);
  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 150,
      cellClassName: (params) => { return "CostingPrd" }
    },
    { field: 'color', headerName: 'Color', filterable: false, sortable: false, editable: false, width: 85 },
    { field: 'size', headerName: 'Size', filterable: false, sortable: false, editable: false, width: 75 },
    { field: 'pack', headerName: 'Pack', filterable: false, sortable: false, editable: false, width: 65 },
    { field: 'sale', headerName: 'Sale', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.sale) }
    },
    { field: 'returnPct', headerName: 'Return', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return params.row.returnPct <= 0 ? 'PerfPositive' : 'PerfNegative' }
    },
    { field: 'netSale', headerName: 'Ret Sale', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.netSale) }
    },
    { field: 'amzFeePct', headerName: 'Amz/Sale', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
    },
    { field: 'lfhCostPct', headerName: 'LFH/Sale', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
    },
    { field: 'othGainPct', headerName: 'Oth/Sale', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
    },
    { field: 'grossPct', headerName: 'Gross/Sale', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return params.row.grossPct > 0 ? 'PerfPositive' : 'PerfNegative' }
    },
    { field: 'tacos', headerName: 'TACOS/Sale', filterable: false, sortable: false, editable: false, width: 95,
      renderCell: (params) => {return isZero(params.row.sale) ? 'NA' : getValue1Decimal(params.row.tacos) + '%'},
      cellClassName: (params) => { return isZero(params.row.sale) ? 'PerfNegative' : 
                                          params.row.tacos <= 25 ? 'PerfPositive' : 'PerfNegative' }
    },
    { field: 'xneetiPct', headerName: 'Xneeti/Sale', filterable: false, sortable: false, editable: false, width: 95,
      valueFormatter: (value: any) => getValue1Decimal(value) + '%',
    },
    { field: 'othFeePct', headerName: 'Oth Fee/Sale', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (value: any) => getValue1Decimal(value) + '%',
    },
    { field: 'netOnSale', headerName: 'Net/Sale', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return params.row.netOnSale > 0 ? 'PerfPositive' : 'PerfNegative' }
    },
    { field: 'netOnLfh', headerName: 'Net/LFH', filterable: false, sortable: false, editable: false, width: 85,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return params.row.netOnLfh > 0 ? 'PerfPositive' : 'PerfNegative' }
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getAllProducts(appContext,
      (response: any) => {
        setPrdList(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  },[]);

  useEffect(() => {
    getMarginData();
  }, [searchData, page, pageSize]);

  function getMarginData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getProductMargin(searchData, page, pageSize, appContext,
        (response: any) => {
          setMarginData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const getValue1Decimal = (value: any) => {
    return isEmpty(value) ? 'NA' : formatTo1Decimal(value);
  }

  const getValue0Decimal = (value: any) => {
    return isEmpty(value) ? 'NA' : formatTo0Decimal(value);
  }

  function getClassNamePerf(value: any) {
    return isEmpty(value) ? '' : value <= 0 ? "PerfNegative" : "PerfPositive";
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }
  
  const search = (data: any) => {
    setPage(0);
    setSearchData(data);
  }

  const updateAttributeList = (invProduct: any) => {
    setLoading(true);
    getInvAttribute(invProduct, appContext,
      (response: any) => {
        setColorList(response.data[0]);
        setSizeList(response.data[1]);
        setPackList(response.data[2]);
        appContext.setShowLoader(false);
        appContext.setSuccessMessage(response.message)
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1} alignItems="center">
        <Grid xs={2}>
          <IDropdown name='product' label='Product' itemList={['Total', ...prdList]} allItemRequired={true} 
            onChangeEvent={(e: any) => {updateAttributeList(e.target.value);}} />
        </Grid>
        <Grid xs={2}>
          <IDropdown name='color' label='Color' itemList={['Total', ...colorList]} allItemRequired={true} />
        </Grid>
        <Grid xs={2}>
          <IDropdown name='size' label='Size' itemList={['Total', ...sizeList]} allItemRequired={true} />
        </Grid>
        <Grid xs={2}>
          <IDropdown name='pack' label='Pack' itemList={['Total', ...packList]} allItemRequired={true} />
        </Grid>
        <Grid xs={1.5}>
          <IDateField name='startDate' label='Start Date' required={true} />
        </Grid>
        <Grid xs={1.5}>
          <IDateField name='endDate' label='End Date' required={true} />
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='inactive' label='Inactive' required={true} defaultChecked={false} />
        </Grid>
      </Grid>
    </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={marginData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        getRowId={(row: any) => row.id} maxHeight={420}/>
    </>
  }

  return <TitlePanel title='Product Margin' panelBody={getMainPanel()} />
}

export default AmazonProductMargin;